import * as React from "react"

import { styled, Theme } from "@mui/material/styles"

export interface StyledForMobileProps {
    isMobile?: boolean
}

export function styledForMobile<
    C extends React.ElementType,
    P extends object = object
>(
    component: C,
    otherProps: (keyof P)[] = []
) {
    const propsToNotForward = [...otherProps.map(String), "isMobile"];

    return styled(component as React.ComponentType, {
        shouldForwardProp: (prop) => !propsToNotForward.includes(String(prop)),
    }) as unknown as <
        Additional extends object = object
    >(
        _styles: (
            _props: StyledForMobileProps &
                React.ComponentProps<C> &
                P &
                Additional & { theme: Theme }
        ) => object
    ) => React.ComponentType<
        StyledForMobileProps & React.ComponentProps<C> & P & Additional
    >
}